/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/aria-proptypes */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import head from 'lodash/head';
import get from 'lodash/get';
import moment from 'moment';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import paymentContent, { contentPropTypes } from './payment.content';
import { invalidBatchNameCharactersRegex, referenceMaxLength } from '../../../config';
import {
	showAddNewPaymentButton,
	getPaymentsHaveFromAndToAccount,
	isMultiplePayments,
	isNumberOfPaymentsLimit,
	isBatchEligible,
	getPaymentsTotal,
	getPaymentIdsforSameReference,
	getPaymentIdsforSameDate,
	getAnyPaymentToBillerOrCreditCard,
	isAnyFutureDatedPaymentUnsupported,
	getFirstPaymentIsFutureDated,
	isRepeatingPayment,
	canApplySameForAll,
	hasTransactionLimitError,
} from '../../../states/payments/selectors';
import { getPaymentsList } from '../../../states/payments/getPaymentsList';

import { formValid } from '../../../states/validation/selectors';
import paymentPropTypes from '../../../states/payments/propTypes';
import { addPayment, copyRefToAll, copyDateToAll, checkIsPayeeOnSRDList } from '../../../states/payments/actions';
import { getToAccounts, getFromAccounts } from '../../../states/accounts/selectors';
import { getPayees } from '../../../states/payees/selectors';
import { getBatchTotalLimitExceeded } from '../../../states/batch/selectors';
import { isMultiTransactions, hasPaymentCapability, isAuthorisationEdit } from '../../../states/modes/selectors';
import { toggleBatch, updateBatchName } from '../../../states/batch/actions';
import { showAllErrors } from '../../../states/validation/actions';
import accountPropTypes, { fromAccountPropType, toAccountPropType } from '../../../states/accounts/propTypes';
import payeePropTypes from '../../../states/payees/propTypes';
import { submitDeleteTemplate } from '../../../states/templates/actions';
import { getCurrentTemplateId, getTemplateName } from '../../../states/templates/selectors';
import PaymentListLayout from '../../../sharedComponents/PaymentListLayout';
import FasterPayment from './FasterPayment';
import { cleanIllegalFasterPaymentsCharacters } from '../../../helpers/fieldHelpers';
import { getPayeeById } from '../../../states/commonSelectors/selectors';
import { getPayeeSrdCheck } from '../../../states/payees/actions';

export const cleanBatchName = (batchName) => batchName.replace(invalidBatchNameCharactersRegex, '');
export const getFasterPaymentsMaxDate = () => moment().add(1, 'year');

const mapState = (state) => ({
	payments: getPaymentsList(state),
	showAddNewPaymentButton: showAddNewPaymentButton(state),
	isMultiplePayments: isMultiplePayments(state),
	paymentsHaveFromAndToAccount: getPaymentsHaveFromAndToAccount(state),
	hasPaymentCapability: hasPaymentCapability(state),
	isNumberOfPaymentsLimit: isNumberOfPaymentsLimit(state),
	isBatchEligible: isBatchEligible(state),
	paymentsTotal: getPaymentsTotal(state),
	isFormValid: formValid(state),
	paymentIdsForSameReference: getPaymentIdsforSameReference(state),
	getPaymentIdsforSameDate: getPaymentIdsforSameDate(state),
	isAnyPaymentToCreditCardOrBiller: getAnyPaymentToBillerOrCreditCard(state),
	isAnyFutureDatedPaymentUnsupported: isAnyFutureDatedPaymentUnsupported(state),
	isFirstPaymentFutureDated: getFirstPaymentIsFutureDated(state),
	isAuthorisationEdit: isAuthorisationEdit(state),
	toAccounts: getToAccounts(state),
	fromAccounts: getFromAccounts(state),
	toPayees: getPayees(state),
	isRepeatingPayment: isRepeatingPayment(state),
	allowApplySameForAll: canApplySameForAll(state),
	isMultiTransactions: isMultiTransactions(state),
	isBatchLimitExceeded: getBatchTotalLimitExceeded(state),
	templateId: getCurrentTemplateId(state),
	templateName: getTemplateName(state),
	getPayeeById: (id) => getPayeeById(state, id),
});

const mapDispatch = (dispatch) => ({
	handleToggleIsBatch: (isBatch) => dispatch(toggleBatch(isBatch)),
	addPayment: () => dispatch(addPayment()),
	handleBatchNameChanged: (event) =>
		dispatch(
			updateBatchName({
				name: cleanBatchName(event.target.value),
			})
		),
	copyRefToAllAction: (paymentIdsForSameReference, reference) =>
		dispatch(copyRefToAll(paymentIdsForSameReference, reference)),
	copyDateToAllAction: (getPaymentIdsforSameDate, date) => dispatch(copyDateToAll(getPaymentIdsforSameDate, date)),
	showAllErrors: () => dispatch(showAllErrors()),
	handleDeleteTemplate: () => dispatch(submitDeleteTemplate()),
	getPayeeSrdCheck: (sortCodeAccountNumber) => dispatch(getPayeeSrdCheck(sortCodeAccountNumber)),
});

export const shouldProgressReveal = ({
	isMultiplePayments,
	isMultiTransactions,
	paymentsHaveFromAndToAccount,
	templateMode,
}) => {
	if (isMultiplePayments || isMultiTransactions || templateMode) {
		return false;
	}

	return !paymentsHaveFromAndToAccount;
};

class PaymentList extends Component {
	constructor(props) {
		super(props);

		this.copyFirstRefToAll = this.copyFirstRefToAll.bind(this);
		this.copyFirstDateToAll = this.copyFirstDateToAll.bind(this);
		this.handleTypeTooltip = this.handleTypeTooltip.bind(this);
		this.handleReferenceTooltip = this.handleReferenceTooltip.bind(this);
		this.updateActiveRow = this.updateActiveRow.bind(this);
		this.handleSameRef = this.handleSameRef.bind(this);
		this.handleSameDate = this.handleSameDate.bind(this);
		this.copyRefToAll = this.copyRefToAll.bind(this);
		this.copyDateToAll = this.copyDateToAll.bind(this);

		this.state = {
			typeTooltipHelpOpen: false,
			refTooltipHelpOpen: false,
			showSameRefPopover: false,
			showSameDatePopover: false,
			activeRowId: '',
		};
	}

	componentDidMount() {
		this.determineIfPayeeIsOnSRDList();
	}

	componentDidUpdate(prevProps) {
		// It's ok to call determineIfPayeeIsOnSRDList multiple times, as the number of payments the user is making may
		// change.
		if (prevProps.payments.length !== this.props.payments.length) {
			this.determineIfPayeeIsOnSRDList();
		}

		// It's ok to call determineIfPayeeIsOnSRDList multiple times, as the payees may not have loaded yet depending
		// on the async order of the redux actions.
		if (prevProps.toPayees.length !== this.props.toPayees.length) {
			this.determineIfPayeeIsOnSRDList();
		}
	}

	determineIfPayeeIsOnSRDList = () => {
		const { payments, getPayeeSrdCheck, getPayeeById } = this.props;

		if (payments.length === 1) {
			const toAccountId = get(payments, '[0].toAccount');
			const payee = getPayeeById(toAccountId);
			const account_number = get(payee, 'to_account.account_number', '');
			const sort_code = get(payee, 'to_account.sort_code', '');
			const sortCodeAccountNumber = sort_code.concat(account_number);
			// This redux action will mark the matching payee in redux state with their isCopCheckRequired flag
			getPayeeSrdCheck(sortCodeAccountNumber);
		}
	};

	copyFirstRefToAll() {
		const { isAnyPaymentToCreditCardOrBiller, paymentIdsForSameReference, copyRefToAllAction, payments } = this.props;
		const { reference } = head(payments);

		copyRefToAllAction(paymentIdsForSameReference, reference);

		if (isAnyPaymentToCreditCardOrBiller) {
			this.setState({ showSameRefPopover: true });
		}
	}

	copyFirstDateToAll() {
		const {
			isAnyFutureDatedPaymentUnsupported,
			isFirstPaymentFutureDated,
			getPaymentIdsforSameDate,
			copyDateToAllAction,
			payments,
		} = this.props;

		const { date } = head(payments);
		copyDateToAllAction(getPaymentIdsforSameDate, date);

		if (isFirstPaymentFutureDated && isAnyFutureDatedPaymentUnsupported) {
			this.setState({ showSameDatePopover: true });
		}
	}

	copyRefToAll(reference) {
		const { isAnyPaymentToCreditCardOrBiller, paymentIdsForSameReference, copyRefToAllAction } = this.props;

		copyRefToAllAction(paymentIdsForSameReference, reference);

		if (isAnyPaymentToCreditCardOrBiller) {
			this.setState({ showSameRefPopover: true });
		}
	}

	copyDateToAll(date) {
		const {
			isAnyFutureDatedPaymentUnsupported,
			isFirstPaymentFutureDated,
			getPaymentIdsforSameDate,
			copyDateToAllAction,
		} = this.props;

		copyDateToAllAction(getPaymentIdsforSameDate, date);

		if (isFirstPaymentFutureDated && isAnyFutureDatedPaymentUnsupported) {
			this.setState({ showSameDatePopover: true });
		}
	}

	handleTypeTooltip(event) {
		event.preventDefault();
		this.setState({ typeTooltipHelpOpen: !this.state.typeTooltipHelpOpen });
	}

	handleReferenceTooltip(event) {
		event.preventDefault();
		this.setState({ refTooltipHelpOpen: !this.state.refTooltipHelpOpen });
	}

	updateActiveRow(id) {
		this.setState({ activeRowId: id });
	}

	handleSameRef(event) {
		event.preventDefault();
		this.setState({ showSameRefPopover: false });
	}

	handleSameDate(event) {
		event.preventDefault();
		this.setState({ showSameDatePopover: false });
	}

	render() {
		return (
			<PaymentListLayout
				{...{ ...this.props, ...this.state }}
				copyFirstRefToAll={this.copyFirstRefToAll}
				copyFirstDateToAll={this.copyFirstDateToAll}
				copyRefToAll={this.copyRefToAll}
				copyDateToAll={this.copyDateToAll}
				handleTypeTooltip={this.handleTypeTooltip}
				handleReferenceTooltip={this.handleReferenceTooltip}
				updateActiveRow={this.updateActiveRow}
				handleSameRef={this.handleSameRef}
				handleSameDate={this.handleSameDate}
				PaymentComponent={FasterPayment}
				referenceMaxLength={referenceMaxLength}
				hasTransactionLimitError={hasTransactionLimitError}
				maxDate={getFasterPaymentsMaxDate()}
				cleanIllegalCharacters={cleanIllegalFasterPaymentsCharacters}
			/>
		);
	}
}

PaymentList.propTypes = {
	payments: PropTypes.arrayOf(PropTypes.shape(paymentPropTypes)).isRequired,
	addPayment: PropTypes.func.isRequired,
	showAddNewPaymentButton: PropTypes.bool.isRequired,
	isMultiplePayments: PropTypes.bool.isRequired,
	paymentsHaveFromAndToAccount: PropTypes.bool.isRequired,
	isNumberOfPaymentsLimit: PropTypes.bool.isRequired,
	hasPaymentCapability: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	frequencyLabel: PropTypes.string,
	firstPaymentLabel: PropTypes.string,
	stopPaymentLabel: PropTypes.string,
	stopOnNumberLabel: PropTypes.string,
	stopOnDateLabel: PropTypes.string,
	isBatch: PropTypes.bool.isRequired,
	batchName: PropTypes.string.isRequired,
	handleToggleIsBatch: PropTypes.func.isRequired,
	handleBatchNameChanged: PropTypes.func.isRequired,
	isBatchEligible: PropTypes.bool.isRequired,
	paymentsTotal: PropTypes.string,
	showAllErrors: PropTypes.func.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	paymentIdsForSameReference: PropTypes.arrayOf(PropTypes.string),
	getPaymentIdsforSameDate: PropTypes.arrayOf(PropTypes.string),
	isAnyPaymentToCreditCardOrBiller: PropTypes.bool.isRequired,
	isAnyFutureDatedPaymentUnsupported: PropTypes.bool.isRequired,
	isFirstPaymentFutureDated: PropTypes.bool.isRequired,
	isAuthorisationEdit: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	copyRefToAllAction: PropTypes.func.isRequired,
	copyDateToAllAction: PropTypes.func.isRequired,
	batchId: PropTypes.string.isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)).isRequired,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	isRepeatingPayment: PropTypes.bool.isRequired,
	allowApplySameForAll: PropTypes.bool.isRequired,
	isMultiTransactions: PropTypes.bool.isRequired,
	isBatchLimitExceeded: PropTypes.bool.isRequired,
	showErrors: PropTypes.bool.isRequired,
	showValidation: PropTypes.bool.isRequired,
	templateMode: PropTypes.bool,
	updateValidation: PropTypes.func,
	validations: PropTypes.shape({}),
	hideErrorMsg: PropTypes.func,
	handleDeleteTemplate: PropTypes.func,
	templateId: PropTypes.string,
	templateName: PropTypes.string,
	isManagePaymentEdit: PropTypes.bool.isRequired,
	handleAddMore: PropTypes.func,
	referenceMaxLength: PropTypes.string,
	hasTransactionLimitError: PropTypes.func,
	cleanIllegalCharacters: PropTypes.func,
	getPayeeSrdCheck: PropTypes.func,
};
export const ConnectWrapper = connect(mapState, mapDispatch)(PaymentList);

const contentWrapper = withContent({ content: paymentContent });
export default connect(mapState, mapDispatch)(withScrollTop(contentWrapper(PaymentList)));
